import { render } from "./App.vue?vue&type=template&id=d796dc36"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=d796dc36&lang=css"

import exportComponent from "/opt/atlassian/pipelines/agent/build/avalia-assess/avalia-playbook-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__